/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { useLenis } from "../SmoothScroll";
import dr_samir from "../../assets/images/about-page/dr_samir_new.png";
import AboutMRI5 from "../../assets/images/other-pages/cmo_big.jpg";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import abstruct from "../../assets/images/other-pages/abstract_4.png";
import shape from "../../assets/images/home-page/7-01-01.png";

import DoneIcon from "@mui/icons-material/Done";
import { Helmet } from "react-helmet-async";
const MedicalOfficer = () => {
  const lenisRef = useLenis();
  useEffect(() => {
    lenisRef?.current?.scrollTo(0); // top of the page
  }, []);
  return (
    <>
      <Helmet>
        <title>Chief Medical Officer | Radiology Specialist - Florida</title>
        <meta
          name="description"
          content="Meet Chief Medical Officer Dr. Samir Amin leading a radiologist-operated imaging center with expertise in diagnostic radiology, protocol design and interpretation.
"
        />
        <meta
          name="keywords"
          content="Chief Medical Officer
Radiology Specialist
radiologist
radiology and imaging specialists
community radiology


"
        />
      </Helmet>
      <div className="flex justify-center flex-col items-start  md:pt-20 pt-14 xl:pt-48 text-[#ccc]">
        <h1 className=" lg:text-[52px] text-[28px] leading-[1.4em]  text-[#f5f5f5] font-normal font-heading  px-2  text-center capitalize  w-full">
          Samir Kamalesh Amin, MD
        </h1>
        <p className="font-bold mb-3  text-center w-full">
          (Chief Medical Director & Diagnostic Radiologist)
        </p>
        <p className=" xl:mb-20 font-bold md:px-8 px-4 text-center w-full">
          Imaging Leadership. Academic Rigor. Patient-First Care.
        </p>

        <div className="lg:w-[90%] w-[95%] mx-auto lg:py-16 py-8">
          <div className="grid xl:grid-cols-2 grid-cols-1 gap-10 justify-center items-center bg-[#0F0F0F] xl:p-20 py-10 rounded-xl">
            <div className=" flex flex-col justify-center items-start px-5 xl:px-0">
              <h3 className="lg:text-[38px] text-[24px] leading-[1.4em] text-[#f5f5f5] font-normal font-heading capitalize pb-5">
                Introduction
              </h3>
              <p>
                Dr. Samir Kamalesh Amin is a{" "}
                <span className="font-bold">
                  {" "}
                  board-certified diagnostic radiologist, Chief Medical Director
                </span>
                , and{" "}
                <span className="font-bold">Radiation Safety Officer</span> at
                Citrus Diagnostic Center.
              </p>
              <p className="mt-6">
                With advanced fellowship training, extensive academic and VA
                leadership experience, and a research background spanning
                neuroradiology, musculoskeletal imaging, cardiovascular MRI, and
                nuclear medicine, Dr. Amin brings{" "}
                <span className="font-bold">
                  {" "}
                  academic-level imaging expertise to{" "}
                </span>{" "}
                a patient-centered outpatient environment.
              </p>
            </div>
            <div className="  flex justify-center items-center  ">
              <div className="text-[20px] leading-[34px] lg:my-3 flex justify-center items-start pb-3">
                <img
                  src={dr_samir}
                  alt="Dr Samir K Amin MD of Citrus Diagnostic Center Florida"
                  className="w-full h-auto rounded-xl "
                />
              </div>
            </div>
          </div>
        </div>
        <div
          className="w-full"
          style={{
            background: `url(${abstruct}),#2e0504`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div className="py-10 lg:w-[90%] w-[95%] mx-auto my-10 ">
            <div
              style={{
                background: "linear-gradient(#ffffff0d 0%, #ffffff14 100%)",
              }}
              className="  2xl:px-16 pt-8 pb-14 rounded-xl  backdrop-blur-xl "
            >
              <div className="2xl:px-14 xl:px-8 px-6 text-center pb-10">
                <h2 className="lg:text-[38px] text-[24px] leading-[1.4em] text-[#f5f5f5] font-normal font-heading capitalize  my-2 ">
                  Clinical & academic leadership
                </h2>
                <p className="">
                  Dr. Amin’s career bridges
                  <span className="font-bold">
                    {" "}
                    academic medicine, federal healthcare systems, and advanced
                    outpatient imaging.
                  </span>
                </p>{" "}
              </div>
              <div className="grid xl:grid-cols-2 grid-cols-1 xl:gap-24 gap-4 xl:pt-10 px-5 xl:px-0">
                <div className="  flex flex-col justify-center items-start  ">
                  <h3 className="lg:text-[24px] font-heading text-[18px] leading-[1.4em] text-[#cccccc] font-bold  pb-5">
                    Current Role
                  </h3>
                  <div className=" lg:gap-10 gap-5 ">
                    <div className="w-full ">
                      <p className="font-bold">
                        Citrus Diagnostic Center – Crystal River, Florida
                      </p>
                      <ul className="list-disc  flex flex-col gap-3 py-2 text-left font-robout">
                        <li className="flex items-start gap-2">
                          <KeyboardArrowRightIcon className="mt-1 text-[#bf9c5e]" />
                          Chief Medical Director
                        </li>
                        <li className="flex items-start gap-2">
                          <KeyboardArrowRightIcon className="mt-1 text-[#bf9c5e]" />
                          Diagnostic Radiologist
                        </li>
                        <li className="flex items-start gap-2">
                          <KeyboardArrowRightIcon className="mt-1 text-[#bf9c5e]" />
                          Radiation Safety Officer
                        </li>
                      </ul>
                      <p className="mt-6 pb-1.5 ">
                        As Chief Medical Director, Dr. Amin oversees:
                      </p>
                      <ul className="list-disc  flex flex-col gap-3 py-2  text-left font-robout">
                        <li className="flex items-start gap-2">
                          <KeyboardArrowRightIcon className="mt-1 text-[#bf9c5e]" />
                          Imaging protocols and quality standards
                        </li>
                        <li className="flex items-start gap-2">
                          <KeyboardArrowRightIcon className="mt-1 text-[#bf9c5e]" />
                          Radiation safety and dose optimization
                        </li>
                        <li className="flex items-start gap-2">
                          <KeyboardArrowRightIcon className="mt-1 text-[#bf9c5e]" />
                          Technology adoption and AI integration
                        </li>
                        <li className="flex items-start gap-2">
                          <KeyboardArrowRightIcon className="mt-1 text-[#bf9c5e]" />
                          Clinical collaboration with referring providers
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className=" rounded-xl   flex-col">
                  <h3 className="lg:text-[24px] font-heading text-[18px] mb-3 leading-[1.4em] text-[#cccccc] font-bold">
                    Prior Appointments
                  </h3>
                  <ul className="list-disc  flex flex-col gap-3 py-2 text-left font-robout">
                    <li className="flex items-start  gap-2">
                      {" "}
                      <KeyboardArrowRightIcon className="mt-1 text-[#bf9c5e]" />
                      <p>
                        <span className="font-bold">
                          Assistant Professor of Radiology
                        </span>
                        , Emory University
                      </p>
                    </li>
                    <li className="flex items-start gap-2">
                      {" "}
                      <KeyboardArrowRightIcon className="mt-1 text-[#bf9c5e]" />
                      <p>
                        <span className="font-bold">
                          Diagnostic Radiologist
                        </span>
                        , Atlanta VA Medical Center
                      </p>
                    </li>
                    <li className="flex items-start gap-2">
                      {" "}
                      <KeyboardArrowRightIcon className="mt-1 text-[#bf9c5e]" />
                      <p>
                        <span className="font-bold">
                          Diagnostic Radiologist
                        </span>
                        , VA Palo Alto Health Care System
                      </p>
                    </li>
                    <li className="flex items-start gap-2">
                      {" "}
                      <KeyboardArrowRightIcon className="mt-1 text-[#bf9c5e]" />
                      <p>
                        <span className="font-bold">
                          Diagnostic Radiologist
                        </span>
                        , McGaw Medical Center of Northwestern University
                      </p>
                    </li>
                    <li className="flex items-start gap-2">
                      {" "}
                      <KeyboardArrowRightIcon className="mt-1 text-[#bf9c5e]" />
                      <p>
                        <span className="font-bold">
                          Diagnostic Radiologist
                        </span>
                        , The George Washington University
                      </p>
                    </li>
                  </ul>
                  <p className="mt-6 pb-1.5">
                    These roles reflect sustained involvement in:
                  </p>
                  <ul className="list-disc  flex flex-col gap-3 py-2  text-left font-robout">
                    <li className="flex items-start gap-2">
                      <KeyboardArrowRightIcon className="mt-1 text-[#bf9c5e]" />
                      High-volume, high-acuity imaging environments
                    </li>
                    <li className="flex items-start gap-2">
                      <KeyboardArrowRightIcon className="mt-1 text-[#bf9c5e]" />
                      Academic teaching and resident education
                    </li>
                    <li className="flex items-start gap-2">
                      <KeyboardArrowRightIcon className="mt-1 text-[#bf9c5e]" />
                      Multidisciplinary clinical decision-making
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="lg:w-[90%] w-[95%] mx-auto lg:pt-16 pt-8">
          <div className="  xl:px-16 xl:py-16 py-8  bg-[#0F0F0F] rounded-xl">
            <div className="2xl:px-14 xl:px-8 px-6 text-center xl:pb-10">
              <h2 className="lg:text-[38px] text-[24px] leading-[1.4em] text-[#f5f5f5] font-normal font-heading capitalize  my-2 ">
                Education, Training & Board Certification
              </h2>
              <p className="w-full md:w-[60%] mx-auto">
                Dr. Samir Amin completed comprehensive academic and subspecialty
                training at nationally recognized institutions, forming the
                foundation of Citrus Diagnostic Center’s advanced diagnostic
                capabilities.
              </p>{" "}
            </div>

            <div className="grid xl:grid-cols-2 grid-cols-1 xl:gap-24 py-10">
              <div className=" xl:bg-[#000] rounded-xl xl:p-8 px-5 ">
                <h3 className="lg:text-[24px] text-[18px] leading-[1.4em] text-[#cccccc] font-normal py-3">
                  Fellowship & Subspecialty Training
                </h3>
                <ul className="flex flex-col gap-3 text-left font-robout">
                  <li className="">
                    <p>
                      <span className="font-bold lg:text-[18px] text-[16px] ">
                        {" "}
                        MR-Predominant Body Imaging & Musculoskeletal
                        Fellowship{" "}
                      </span>
                    </p>
                    <p className="py-2">
                      Northwestern University – Chicago, Illinois
                    </p>
                    <p className="py-2">
                      Advanced fellowship training emphasizing MRI-based body
                      and musculoskeletal imaging, including complex abdominal,
                      pelvic, prostate, and orthopedic MRI protocols.
                    </p>
                  </li>
                  <li className="">
                    <p>
                      <span className="font-bold lg:text-[18px] text-[16px]">
                        {" "}
                        Nuclear Medicine & Cardiac Imaging Mini-Fellowship{" "}
                      </span>
                    </p>
                    <p className="py-2">
                      The George Washington University – Washington, DC
                    </p>
                    <p className="py-2">
                      Focused advanced training in nuclear medicine, PET-based
                      diagnostics, cardiac imaging, and myocardial perfusion
                      applications.
                    </p>
                  </li>
                </ul>
                <h3 className="lg:text-[24px] text-[18px] leading-[1.4em] text-[#cccccc] font-normal py-3">
                  Diagnostic Radiology Residency
                </h3>
                <ul className="flex flex-col gap-3 text-left font-robout">
                  <li className="">
                    <p>
                      <span className="font-bold lg:text-[18px] text-[16px]">
                        {" "}
                        The George Washington University{" "}
                      </span>
                    </p>
                    <p className="py-2">Washington, DC</p>
                    <p className="py-2">
                      Completed residency training at a major academic medical
                      center and Level I Trauma Center, with extensive
                      experience in cross-sectional imaging, MRI, CT,
                      ultrasound, and nuclear medicine.
                    </p>
                    <p className="py-2">
                      Dr. Amin was selected to serve as Chief Resident,
                      reflecting leadership, academic distinction, and peer
                      recognition within a high-acuity academic environment.
                    </p>
                  </li>
                </ul>
              </div>
              <div className="  xl:p-8 px-5 ">
                <h3 className="lg:text-[24px] text-[18px] leading-[1.4em] text-[#cccccc] font-normal py-3">
                  Transitional Year Residency
                </h3>
                <ul className="flex flex-col gap-3 text-left font-robout">
                  <li className="">
                    <p>
                      <span className="font-bold lg:text-[18px] text-[16px]">
                        {" "}
                        UPMC Mercy{" "}
                      </span>
                    </p>
                    <p className="py-2">Pittsburgh, Pennsylvania</p>
                    <p className="py-2">
                      Clinical training in internal medicine, providing a strong
                      foundation in multidisciplinary patient care and
                      diagnostic decision-making.
                    </p>
                  </li>
                </ul>
                <h3 className="lg:text-[24px] text-[18px] leading-[1.4em] text-[#cccccc] font-normal py-3">
                  Medical Education
                </h3>
                <ul className="flex flex-col gap-3 text-left font-robout">
                  <li className="">
                    <p className="flex flex-col">
                      <span className="font-bold lg:text-[18px] text-[16px]">
                        {" "}
                        Doctor of Medicine{" "}
                      </span>
                      <span className="font-bold lg:text-[18px] text-[16px]">
                        {" "}
                        Baylor College of Medicine{" "}
                      </span>
                    </p>
                    <p className="py-2">Houston, Texas</p>
                    <p className="py-2">
                      Dr. Amin completed the prestigious Rice/Baylor Medical
                      Scholars (BS/MD) Program, graduating with academic
                      distinction and demonstrating an early and sustained
                      commitment to excellence in medicine.
                    </p>
                  </li>
                </ul>
                <h3 className="lg:text-[24px] text-[18px] leading-[1.4em] text-[#cccccc] font-normal py-3">
                  Board Certification & Licensure
                </h3>
                <ul className="text-[#cccccc] leading-[1.4em] font-robout font-medium space-y-2 mt-3">
                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon
                      className="text-[#bf9c5e] mt-[2px]"
                      fontSize="small"
                    />
                    <span>American Board of Radiology – Board Certified</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon
                      className="text-[#bf9c5e] mt-[2px]"
                      fontSize="small"
                    />
                    <span>ACLS & BLS Certified</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <KeyboardArrowRightIcon
                      className="text-[#bf9c5e] mt-[2px]"
                      fontSize="small"
                    />
                    <span>Florida Medical License</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className=" flex mx-auto overflow-hidden">
            <div className="md:px-0 px-1 lg:pt-20 pt-10 md:pb-5  w-full ">
              <img
                src={AboutMRI5}
                alt="Trauma, TBI & personal injury imaging"
                className="object-cover w-full rounded-xl"
              />{" "}
            </div>
          </div>
          <div className="py-10">
            <div
              style={{
                backgroundImage:
                  "linear-gradient(to right, #3D0E26 0%, #8B5E3C 50%, #330A16 100%)",
              }}
              className="  2xl:px-16 xl:py-12 py-8 rounded-xl "
            >
              <div className="grid xl:grid-cols-2 grid-cols-1 xl:gap-24 gap-8 pt-3">
                <div className=" flex flex-col justify-center items-start px-5 xl:px-0">
                  <h2 className="lg:text-[38px] text-[24px] leading-[1.4em] text-[#f5f5f5] font-normal font-heading  pb-3 capitalize ">
                    Trauma, TBI & personal injury imaging expertise
                  </h2>
                  <p className="pb-2">
                    Dr. Amin’s background includes extensive experience at{" "}
                    <span className="font-bold">Level 1 trauma centers </span>{" "}
                    and VA hospitals, interpreting:
                  </p>{" "}
                  <ul className="list-disc  flex flex-col gap-2 py-2 text-left font-robout">
                    <li className="flex items-start gap-2">
                      {" "}
                      <DoneIcon className="mt-1 text-[#bf9c5e]" />
                      Emergency and trauma CT
                    </li>
                    <li className="flex items-start gap-2">
                      {" "}
                      <DoneIcon className="mt-1 text-[#bf9c5e]" />
                      Advanced neuroimaging
                    </li>
                    <li className="flex items-start gap-2">
                      <DoneIcon className="mt-1 text-[#bf9c5e]" />
                      High-volume musculoskeletal and spine imaging
                    </li>
                  </ul>
                  <p className="mt-6 pb-2">
                    This expertise underpins Citrus Diagnostic Center’s
                    leadership in:
                  </p>
                  <ul className=" flex flex-col gap-2 py-2 text-left font-robout">
                    <li className="font-bold flex items-start gap-2">
                      {" "}
                      <DoneIcon className="mt-1 text-[#bf9c5e]" />
                      Traumatic Brain Injury (TBI) imaging
                    </li>
                    <li className="font-bold flex items-start gap-2">
                      <DoneIcon className="mt-1 text-[#bf9c5e]" />
                      Brain DTI MRI
                    </li>
                    <li className="font-bold flex items-start gap-2">
                      <DoneIcon className="mt-1 text-[#bf9c5e]" />
                      Whiplash protocols
                    </li>
                    <li className="font-bold flex items-start gap-2">
                      <DoneIcon className="mt-1 text-[#bf9c5e]" />
                      Dedicated cervical MRI with alar ligament evaluation
                    </li>
                    <li className="flex items-start gap-2">
                      <DoneIcon className="mt-1 text-[#bf9c5e]" />
                      <p>
                        Auto / PIP / Personal injury imaging across{" "}
                        <span className="font-bold">
                          {" "}
                          X-ray, CT, MRI, ultrasound, and nuclear medicine
                        </span>
                      </p>
                    </li>
                  </ul>
                </div>
                <div className="  px-6">
                  <h2 className="lg:text-[38px] text-[24px] leading-[1.4em] text-[#f5f5f5] font-normal font-heading  pb-3 capitalize ">
                    Research & innovation
                  </h2>
                  <p className="pb-2">
                    Dr. Amin has an extensive research background, with work
                    spanning:
                  </p>{" "}
                  <ul className="list-disc  flex flex-col gap-2 py-2 text-left font-robout">
                    <li className="flex items-start gap-2">
                      {" "}
                      <DoneIcon className="mt-1 text-[#bf9c5e]" />
                      Alzheimer’s disease
                    </li>
                    <li className="flex items-start gap-2">
                      {" "}
                      <DoneIcon className="mt-1 text-[#bf9c5e]" />
                      Cerebral blood flow and neurodegeneration
                    </li>
                    <li className="flex items-start gap-2">
                      {" "}
                      <DoneIcon className="mt-1 text-[#bf9c5e]" />
                      Cardiovascular MRI
                    </li>
                    <li className="flex items-start gap-2">
                      {" "}
                      <DoneIcon className="mt-1 text-[#bf9c5e]" />
                      Liver disease imaging
                    </li>
                    <li className="flex items-start gap-2">
                      {" "}
                      <DoneIcon className="mt-1 text-[#bf9c5e]" />
                      Advanced MRI techniques
                    </li>
                  </ul>
                  <h3 className="lg:text-[24px] text-[18px] leading-[1.4em] text-[#cccccc] font-normal  pt-5 ">
                    National Research Leadership
                  </h3>
                  <ul className="list-disc  flex flex-col gap-3 py-2 text-left font-robout">
                    <li className="flex items-start gap-2">
                      {" "}
                      <DoneIcon className="mt-1 text-[#bf9c5e]" />
                      <p>
                        <span className="font-bold">
                          Co–Primary Investigator{" "}
                        </span>{" "}
                        , VA Department of Veterans Affairs <br />
                        <span className="font-bold my-2">
                          PREMIUM Trial{" "}
                        </span>{" "}
                        <br />{" "}
                        <span className=" italic">
                          {" "}
                          Preventing Liver Cancer Mortality through Imaging with
                          Ultrasound vs. MRI
                        </span>
                      </p>
                    </li>
                  </ul>
                  <p className="py-3">
                    This national randomized trial evaluates imaging strategies
                    for hepatocellular carcinoma screening-reinforcing Dr.
                    Amin’s expertise in{" "}
                    <span className="font-bold">
                      {" "}
                      evidence-based imaging and population health.
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="relative md:max-w-[90%] w-11/12 mx-auto lg:py-20 overflow-hidden xl:bg-[#0f0f0f] rounded-xl mt-8">
          {/* 🔥 Background Shape */}
          <img
            src={shape}
            alt="Ci"
            className="
      absolute 
      top-1/2 
      left-1/2 
      -translate-x-1/2 
      -translate-y-1/2 
      pointer-events-none 
      z-0
      opacity-75
    "
          />

          <div
            className=" backdrop-blur-[2px]
    bg-[#ffffff13] rounded-xl
      shadow-lg xl:w-11/12  mx-auto py-8 xl:py-16 xl:px-10 "
          >
            <div>
              <div className="text-center">
                <h2 className="lg:text-[38px] text-[24px] leading-[1.4em] text-[#f5f5f5] font-normal font-heading  capitalize pt-3 pb-1">
                  philosophy of care
                </h2>
                <p className=" font-bold px-3">
                  Radiology Led by Physicians. Imaging Designed for Patients.
                </p>{" "}
              </div>

              <div className="grid xl:grid-cols-2 grid-cols-1 xl:gap-24 py-10">
                <div className="  xl:p-8 px-5  ">
                  <p className="pb-1.5">Dr. Amin believes:</p>
                  <ul className="list-disc  flex flex-col gap-2 py-2  text-left font-robout">
                    <li className="flex items-start gap-2">
                      {" "}
                      <KeyboardArrowRightIcon className="mt-1 text-[#bf9c5e]" />
                      Imaging quality drives clinical outcomes
                    </li>
                    <li className="flex items-start gap-2">
                      {" "}
                      <KeyboardArrowRightIcon className="mt-1 text-[#bf9c5e]" />
                      Protocols matter as much as equipment
                    </li>
                    <li className="flex items-start gap-2">
                      {" "}
                      <KeyboardArrowRightIcon className="mt-1 text-[#bf9c5e]" />
                      Patients deserve transparency and choice
                    </li>
                    <li className="flex items-start gap-2">
                      {" "}
                      <KeyboardArrowRightIcon className="mt-1 text-[#bf9c5e]" />
                      Radiologists must remain clinically accountable-not
                      corporate-directed
                    </li>
                  </ul>
                </div>
                <div className="flex flex-col justify-center items-start px-5 xl:px-0">
                  <div className="w-full ">
                    <p className="mt-6 pb-1.5">
                      This philosophy is embedded in every aspect of Citrus
                      Diagnostic Center:
                    </p>
                    <ul className="list-disc  flex flex-col gap-2 py-2  text-left font-robout">
                      <li className="flex items-start gap-2">
                        {" "}
                        <KeyboardArrowRightIcon className="mt-1 text-[#bf9c5e]" />
                        From research-grade MRI hardware
                      </li>
                      <li className="flex items-start gap-2">
                        {" "}
                        <KeyboardArrowRightIcon className="mt-1 text-[#bf9c5e]" />
                        To AI-enhanced image acquisition
                      </li>
                      <li className="flex items-start gap-2">
                        {" "}
                        <KeyboardArrowRightIcon className="mt-1 text-[#bf9c5e]" />
                        To careful radiation dose stewardship
                      </li>
                      <li className="flex items-start gap-2">
                        {" "}
                        <KeyboardArrowRightIcon className="mt-1 text-[#bf9c5e]" />
                        To direct radiologist involvement in care
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="lg:w-[90%] w-[95%] mx-auto lg:py-16 py-8">
          <div className="">
            <div
              style={{
                backgroundImage:
                  "linear-gradient(to right, #3D0E26 0%, #8B5E3C 50%, #330A16 100%)",
              }}
              className="  2xl:px-16 xl:pt-12 xl:pb-12 pt-7 pb-2 rounded-xl "
            >
              <div className="grid xl:grid-cols-2 grid-cols-1 xl:gap-24 gap-0 ">
                <div className="  2xl:px-12 py-6 xl:px-8 px-6 flex justify-center items-start flex-col">
                  <h2 className="lg:text-[38px] text-[24px] leading-[1.4em] text-[#f5f5f5] font-normal font-heading  capitalize py-3">
                    why this matters for patients & providers
                  </h2>
                  <div>
                    <p>At Citrus Diagnostic Center:</p>
                    <div className="w-full pt-2">
                      <ul className="list-disc  flex flex-col gap-2 py-2  text-left font-robout">
                        <li className="flex items-start gap-2">
                          {" "}
                          <KeyboardArrowRightIcon className="mt-1 text-[#bf9c5e]" />{" "}
                          <p>
                            Imaging is{" "}
                            <span className="font-bold">
                              {" "}
                              designed and overseen by subspecialty-trained
                              radiologists
                            </span>
                          </p>
                        </li>
                        <li className="flex items-start gap-2">
                          {" "}
                          <KeyboardArrowRightIcon className="mt-1 text-[#bf9c5e]" />{" "}
                          <p>
                            Studies are interpreted by physicians with{" "}
                            <span className="font-bold">
                              {" "}
                              academic and trauma-center experience
                            </span>
                          </p>
                        </li>
                        <li className="flex items-start gap-2">
                          {" "}
                          <KeyboardArrowRightIcon className="mt-1 text-[#bf9c5e]" />
                          <p>
                            Technology adoption follows{" "}
                            <span className="font-bold">
                              evidence-not marketing
                            </span>
                          </p>
                        </li>
                      </ul>
                    </div>
                    <p className="py-3">
                      This approach ensures clarity, accuracy, and trust-whether
                      the imaging is for prevention, diagnosis, treatment
                      planning, or personal injury evaluation.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MedicalOfficer;
